import axios from 'axios';
import { TOKEN_TYPE, CONTENT_TYPE } from '../constants/constants';
import { clearTokens, getAccessToken, getRefreshToken } from '../services/local_storage_service';
import { refreshUser } from '../services/sign_in_service';
import { REACT_ROUTES } from '../constants/react_routes';
import history from '../services/history';

export const getHeaders = (tokenType = TOKEN_TYPE.TOKEN, contentType = CONTENT_TYPE.JSON) => {
    const token = tokenType === TOKEN_TYPE.TOKEN ? getAccessToken() : getRefreshToken();
    return {
        headers: {
            'Accept': contentType,
            'Content-Type': contentType,
            'Authorization': token ? `Bearer ${token}` : undefined
        }
    };
};

export const getRefreshHeaders = async () => {
    const token = await refreshUser();
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : undefined
        }
    };
}

export const getData = async (url, headers = getHeaders()) => {
    let response = await axios.get(url, headers);
    let { status, code, data } = response;

    if (status === 401 || code === 401) {
        const refreshHeaders = await getRefreshHeaders();
        response = await axios.get(url, refreshHeaders);
        ({ status, code, data } = response);
        if (status === 401 || code === 401) {
            clearTokens();
            return history.push(REACT_ROUTES.HOME);
        }
    }

    if (status === 200 || status === 404) {
        return data;
    }
    else if (status === 500) {
        history.push(REACT_ROUTES.ERROR_PAGE);
    }
}

export const postData = async (url, postData, headers = getHeaders()) => {
    let response = await axios.post(url, postData, headers);
    let { status, code, data } = response;
    if (status === 401 || code === 401) {
        const refreshHeaders = await getRefreshHeaders();
        response = await axios.post(url, postData, refreshHeaders);
        ({ status, code, data } = response);
        if (status === 401 || code === 401) {
            clearTokens();
            return history.push(REACT_ROUTES.HOME);
        }
    }
    if (status === 200 || status === 201 || status === 404 || status === 422) {
        return data;
    }
    else if (status === 500) {
        history.push(REACT_ROUTES.ERROR_PAGE);
    }
}

export const putData = async (url, putData, headers = getHeaders()) => {
    let response = await axios.put(url, putData, headers);
    let { status, code, data } = response;
    if (status === 401 || code === 401) {
        const refreshHeaders = await getRefreshHeaders();
        response = await axios.put(url, putData, refreshHeaders);
        ({ status, code, data } = response);
        if (status === 401 || code === 401) {
            clearTokens();
            return history.push(REACT_ROUTES.HOME);
        }
    }

    if (status === 200 || status === 403 || status === 404 || status === 422) {
        return data;
    }
    else if (status === 500) {
        history.push(REACT_ROUTES.ERROR_PAGE);
    }
}

export const patchData = async (url, patchData, headers = getHeaders()) => {
    let response = await axios.patch(url, patchData, headers);
    let { status, code, data } = response;
    if (status === 401 || code === 401) {
        const refreshHeaders = await getRefreshHeaders();
        response = await axios.patch(url, patchData, refreshHeaders);
        ({ status, code, data } = response);
        if (status === 401 || code === 401) {
            clearTokens();
            return history.push(REACT_ROUTES.HOME);
        }
    }

    if (status === 200 || status === 404) {
        return data;
    }
    else if (status === 500) {
        history.push(REACT_ROUTES.ERROR_PAGE);
    }
    else if (status === 400) {
        throw data;
    }
}

export const deleteData = async (url, headers = getHeaders()) => {
    let response = await axios.delete(url, headers);
    let { status, code, data } = response;
    if (status === 401 || code === 401) {
        const refreshHeaders = await getRefreshHeaders();
        response = await axios.delete(url, refreshHeaders);
        ({ status, code, data } = response);
        if (status === 401 || code === 401) {
            clearTokens();
            return history.push(REACT_ROUTES.HOME);
        }
    }

    if (status === 200 || status === 201 || status === 204) {
        return data;
    }
    else if (status === 500) {
        history.push(REACT_ROUTES.ERROR_PAGE);
    }
}
